import React from "react";
import { Layout, Typography } from "antd";

const { Footer } = Layout;
const { Text } = Typography;

const AppFooter = () => {
  return (
    <Footer
      style={{
        display: "flex",
        justifyContent: "flex-end", // Rata kanan
        alignItems: "center",
        flexWrap: "wrap",
        background: "#001529",
        color: "white",
        padding: "15px 30px",
        borderTop: "1px solid rgba(255, 255, 255, 0.2)", // Garis atas halus
        fontSize: "14px",
      }}
    >
      <div style={{ textAlign: "right", width: "100%" }}>
        <Text strong style={{ color: "rgba(255, 255, 255, 0.7)" }}>
          © {new Date().getFullYear()} DM APPS - Daily Meeting Management System
        </Text>
        <br />
        <Text strong style={{ color: "rgba(255, 255, 255, 0.7)" }}>
          Created with ❤️ by Anak Tangga
        </Text>
      </div>
    </Footer>
  );
};

export default AppFooter;
